module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"empty":"Нет ни одной вакансии с заполненным адресом"}}')
  delete Component.options._Ctor
}
